import React from 'react';
import PropTypes from 'prop-types';

function UploadToCloud(props) {
  const { height, iconColor, width } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.2071 16.2929L32.2071 22.2929C32.5976 22.6834 32.5976 23.3166 32.2071 23.7071C31.8166 24.0976 31.1834 24.0976 30.7929 23.7071L26.5 19.414V36C26.5 36.5523 26.0523 37 25.5 37C24.9477 37 24.5 36.5523 24.5 36V19.414L20.2071 23.7071C19.8166 24.0976 19.1834 24.0976 18.7929 23.7071C18.4024 23.3166 18.4024 22.6834 18.7929 22.2929L24.7929 16.2929C25.1834 15.9024 25.8166 15.9024 26.2071 16.2929ZM25.5 8C31.0394 8 34.4054 10.7392 35.3588 16H35.5C39.366 16 42.5 19.134 42.5 23C42.5 26.866 39.366 30 35.5 30H31.5C30.9477 30 30.5 29.5523 30.5 29C30.5 28.4477 30.9477 28 31.5 28H35.5C38.2614 28 40.5 25.7614 40.5 23C40.5 20.2386 38.2614 18 35.5 18H34.5C33.9957 18 33.5703 17.6245 33.5077 17.124C32.9034 12.2897 30.3275 10 25.5 10C22.6583 10 20.5645 10.9984 19.0551 12.6701C18.526 13.2562 18.108 13.8857 17.7913 14.5131L17.6051 14.9073L17.4892 15.1946C17.4755 15.2325 17.4646 15.2652 17.4563 15.2924C17.3278 15.7128 16.9397 16 16.5 16H14.5C11.1863 16 8.5 18.6863 8.5 22C8.5 25.3137 11.1863 28 14.5 28H19.5C20.0523 28 20.5 28.4477 20.5 29C20.5 29.5523 20.0523 30 19.5 30H14.5C10.0817 30 6.5 26.4183 6.5 22C6.5 17.5817 10.0817 14 14.5 14H15.8085C16.1516 13.2159 16.72 12.2721 17.5707 11.3299C19.447 9.25161 22.0718 8 25.5 8Z"
        fill={iconColor}
      />
    </svg>
  );
}
UploadToCloud.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  iconColor: PropTypes.string
};

UploadToCloud.defaultProps = {
  height: '49',
  width: '48',
  iconColor: '#53B7B0'
};

export default UploadToCloud;
